// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VisitsDueDetail-module__rail___nsCjL {
  background: #ffffff;
  border: 1px solid #dcdce0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.VisitsDueDetail-module__section___KRKeZ {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 14px 16px;
  border-bottom: 1px solid #e4e4e7;
}

.VisitsDueDetail-module__header___MUanf {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
}

.VisitsDueDetail-module__name___i3SqI {
  font-size: 17px;
  font-weight: 600;
  color: #18181b;
}

.VisitsDueDetail-module__meta___Qhb1z {
  margin-top: 4px;
  font-size: 12px;
  color: #a1a1aa;
}

.VisitsDueDetail-module__pills___pstWP {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 4px;
}

.VisitsDueDetail-module__sectionTitle___uyRIn {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #71717a;
}

.VisitsDueDetail-module__why___aVcbJ {
  margin: 0;
  font-size: 14px;
  color: #18181b;
}

.VisitsDueDetail-module__muted___vPrnv {
  margin: 0;
  font-size: 13px;
  color: #71717a;
}

.VisitsDueDetail-module__guardrails___fR2bk {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 8px 0 0;
  padding: 0;
  list-style: none;
}

.VisitsDueDetail-module__history___rE7Zb {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.VisitsDueDetail-module__historyItem___H4s00 {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #18181b;
}

.VisitsDueDetail-module__historyCode___pNGrV {
  padding: 1px 6px;
  border: 1px solid #e4e4e7;
  border-radius: 4px;
  background: #fafafa;
  font-family: "IBM Plex Mono", monospace;
  font-size: 12px;
}

.VisitsDueDetail-module__historyCodeMatch___d3vkt {
  border-color: #bbf7d0;
  background: #f0fdf4;
  color: #166534;
}

.VisitsDueDetail-module__historyDate___LSPZA {
  margin-left: auto;
  font-family: "IBM Plex Mono", monospace;
  color: #52525b;
}

.VisitsDueDetail-module__fields___uUQ_q {
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr);
  gap: 2px 12px;
  margin: 0;
  font-size: 13px;
}

.VisitsDueDetail-module__fields___uUQ_q dt {
  color: #71717a;
}

.VisitsDueDetail-module__fields___uUQ_q dd {
  margin: 0;
  color: #18181b;
}

.VisitsDueDetail-module__fields___uUQ_q .VisitsDueDetail-module__fieldEmpty___Il9X0 {
  color: #71717a;
}

.VisitsDueDetail-module__activity___zW1oA {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.VisitsDueDetail-module__activityItem___WxGx9 {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 13px;
}

.VisitsDueDetail-module__activityHead___Z4wPe {
  color: #18181b;
}

.VisitsDueDetail-module__activityMeta___A1Di9 {
  font-size: 12px;
  color: #71717a;
}

.VisitsDueDetail-module__footer___ucTqE {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 16px;
  background: #fafafa;
}

.VisitsDueDetail-module__button___lZ5s7 {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  border-radius: 6px;
  border: 1px solid #e4e4e7;
  background: #ffffff;
  color: #18181b;
  text-decoration: none;
  cursor: pointer;
}
.VisitsDueDetail-module__button___lZ5s7:disabled, .VisitsDueDetail-module__button___lZ5s7[aria-disabled=true] {
  opacity: 0.5;
  cursor: not-allowed;
}

.VisitsDueDetail-module__buttonPrimary___nWYHl {
  border-color: #18181b;
  background: #18181b;
  color: #fafafa;
}

.VisitsDueDetail-module__buttonRight___v7qkZ {
  margin-left: auto;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/VisitsDueView/VisitsDueDetail.module.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AACF;;AAEA;EACE,eAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,QAAA;AACF;;AAEA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,SAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cAAA;AACF;;AAEA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,uCAAA;EACA,eAAA;AACF;;AAEA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AACF;;AAEA;EACE,iBAAA;EACA,uCAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,0CAAA;EACA,aAAA;EACA,SAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,SAAA;EACA,cAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,SAAA;EACA,UAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,eAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,qBAAA;EACA,eAAA;AACF;AACE;EAEE,YAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,qBAAA;EACA,mBAAA;EACA,cAAA;AADF;;AAIA;EACE,iBAAA;AADF","sourcesContent":[".rail {\n  background: #ffffff;\n  border: 1px solid #dcdce0;\n  border-radius: 8px;\n  overflow: hidden;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.section {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 14px 16px;\n  border-bottom: 1px solid #e4e4e7;\n}\n\n.header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n}\n\n.name {\n  font-size: 17px;\n  font-weight: 600;\n  color: #18181b;\n}\n\n.meta {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #a1a1aa;\n}\n\n.pills {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n  gap: 4px;\n}\n\n.sectionTitle {\n  font-size: 11px;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: #71717a;\n}\n\n.why {\n  margin: 0;\n  font-size: 14px;\n  color: #18181b;\n}\n\n.muted {\n  margin: 0;\n  font-size: 13px;\n  color: #71717a;\n}\n\n.guardrails {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 8px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.history {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.historyItem {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #18181b;\n}\n\n.historyCode {\n  padding: 1px 6px;\n  border: 1px solid #e4e4e7;\n  border-radius: 4px;\n  background: #fafafa;\n  font-family: 'IBM Plex Mono', monospace;\n  font-size: 12px;\n}\n\n.historyCodeMatch {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n  color: #166534;\n}\n\n.historyDate {\n  margin-left: auto;\n  font-family: 'IBM Plex Mono', monospace;\n  color: #52525b;\n}\n\n.fields {\n  display: grid;\n  grid-template-columns: 56px minmax(0, 1fr);\n  gap: 2px 12px;\n  margin: 0;\n  font-size: 13px;\n}\n\n.fields dt {\n  color: #71717a;\n}\n\n.fields dd {\n  margin: 0;\n  color: #18181b;\n}\n\n.fields .fieldEmpty {\n  color: #71717a;\n}\n\n.activity {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n}\n\n.activityItem {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  font-size: 13px;\n}\n\n.activityHead {\n  color: #18181b;\n}\n\n.activityMeta {\n  font-size: 12px;\n  color: #71717a;\n}\n\n.footer {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 16px;\n  background: #fafafa;\n}\n\n.button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  font-size: 13px;\n  font-weight: 500;\n  border-radius: 6px;\n  border: 1px solid #e4e4e7;\n  background: #ffffff;\n  color: #18181b;\n  text-decoration: none;\n  cursor: pointer;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n}\n\n.buttonPrimary {\n  border-color: #18181b;\n  background: #18181b;\n  color: #fafafa;\n}\n\n.buttonRight {\n  margin-left: auto;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rail": `VisitsDueDetail-module__rail___nsCjL`,
	"section": `VisitsDueDetail-module__section___KRKeZ`,
	"header": `VisitsDueDetail-module__header___MUanf`,
	"name": `VisitsDueDetail-module__name___i3SqI`,
	"meta": `VisitsDueDetail-module__meta___Qhb1z`,
	"pills": `VisitsDueDetail-module__pills___pstWP`,
	"sectionTitle": `VisitsDueDetail-module__sectionTitle___uyRIn`,
	"why": `VisitsDueDetail-module__why___aVcbJ`,
	"muted": `VisitsDueDetail-module__muted___vPrnv`,
	"guardrails": `VisitsDueDetail-module__guardrails___fR2bk`,
	"history": `VisitsDueDetail-module__history___rE7Zb`,
	"historyItem": `VisitsDueDetail-module__historyItem___H4s00`,
	"historyCode": `VisitsDueDetail-module__historyCode___pNGrV`,
	"historyCodeMatch": `VisitsDueDetail-module__historyCodeMatch___d3vkt`,
	"historyDate": `VisitsDueDetail-module__historyDate___LSPZA`,
	"fields": `VisitsDueDetail-module__fields___uUQ_q`,
	"fieldEmpty": `VisitsDueDetail-module__fieldEmpty___Il9X0`,
	"activity": `VisitsDueDetail-module__activity___zW1oA`,
	"activityItem": `VisitsDueDetail-module__activityItem___WxGx9`,
	"activityHead": `VisitsDueDetail-module__activityHead___Z4wPe`,
	"activityMeta": `VisitsDueDetail-module__activityMeta___A1Di9`,
	"footer": `VisitsDueDetail-module__footer___ucTqE`,
	"button": `VisitsDueDetail-module__button___lZ5s7`,
	"buttonPrimary": `VisitsDueDetail-module__buttonPrimary___nWYHl`,
	"buttonRight": `VisitsDueDetail-module__buttonRight___v7qkZ`
};
module.exports = ___CSS_LOADER_EXPORT___;
